import {Injectable} from '@angular/core';
import {Subscription, timer} from 'rxjs';

@Injectable()
export class Timer {
  private subscription: Subscription;

  public set(delayInMillis: number, callback: () => void): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    this.subscription = timer(delayInMillis).subscribe(() => callback());
  }
}
